import React from 'react';
import cn from 'classnames';
import { size, entries } from 'lodash';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { i18n } from '@lt/localization';
import { ValidationErrorsList } from 'src/components/ValidationErrorsList';
import { HAS_CUSTOMER_FORM } from 'src/routes/Checkout/CheckoutRoutes/PackageCheckout/components/Customer/abFeatures';
import {
  passportValidationText,
  wrongDepartureValidationText,
} from './contstants';
import { TouristNameField, TouristGender, TouristCitizenship } from './Fields';
import TouristBirthday from './Fields/TouristBirthday';
import TouristDocument from './Fields/TouristDocument';
import TouristsFormWarnings from './components/TouristsFormWarnings';
import {
  DOC_TYPES,
  TOURIST_FIELDS as T,
} from '../../routes/Checkout/store/constants/tourists';
import { isRuDoc } from './utils';
import { MODULE_NAME, NATIONALITY_CONSTANTS } from '../../constants';
import { getGenderByName, getGenderByPatronymic } from './utils/sexUtils';
import NameSwicther from './NameSwitcher';
import VisaServiceOptions from '../../routes/Checkout/components/Tourists/VisaServiceOptions';
import SubmitTouristMobile from './SubmitTouristMobile';
import TouristsFormHeader from './components/TouristsFormHeader';
import TouristPatronymicField from './Fields/TouristPatronymicField';

class TouristForm extends React.PureComponent {
  constructor(props) {
    super(props);

    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    // TODO: probably add debounce for some inputs CAREFULLY
    this.saveTouristsDataImmediately = this.saveTouristsData.bind(this);
    this.handleHideInput = this.handleHideInput.bind(this);
    this.handleHidePatronymic = this.handleHidePatronymic.bind(this);
    this.handleValidateTourist = this.handleValidateTourist.bind(this);
    this.handleSwitchName = this.handleSwitchName.bind(this);
    this.handleSwitchNameClose = this.handleSwitchNameClose.bind(this);
    this.onTouristSelect = this.onTouristSelect.bind(this);
    // Fields handlers
    this.handleNameChange = this.handleNameChange.bind(this);
    this.handleSurnameChange = this.handleSurnameChange.bind(this);
    this.handlePatronymicChange = this.handlePatronymicChange.bind(this);
    this.handleDocTypeChange = this.handleDocTypeChange.bind(this);
    this.handleDocumentDateChange = this.handleDocumentDateChange.bind(this);
    this.handleNationalityChange = this.handleNationalityChange.bind(this);
    this.handleGenderChange = this.handleGenderChange.bind(this);
    this.handleVisaServiceChange = this.handleVisaChange.bind(this);
    this.handleBirthdayChange = (value) =>
      this.handleFieldChange('birthday', value);
    this.handleDocumentNumberChange = (value) =>
      this.handleFieldChange('passport_number', value);

    const { visaServices } = this.props;
    const [defaultVisaService] = visaServices || [];
    this.state = {
      [T.DOC_TYPE]: null,
      [T.GENDER]: undefined,
      [T.CITIZENSHIP]: NATIONALITY_CONSTANTS.RU, // Russian
      [T.NAME]: '',
      [T.SURNAME]: '',
      [T.PATROMYMIC]: '',
      [T.BIRTHDAY]: '',
      [T.DOC_NUMBER]: '',
      [T.DOC_EXPIRES_DATE]: '',
      [T.VISA_SUPPORT]: defaultVisaService && defaultVisaService.id,
      hideDocInputs: false,
      hidePatronymic: false,
      swicthNames: undefined,
    };
  }

  UNSAFE_componentWillMount() {
    const { touristData } = this.props;
    if (touristData) {
      this.setState(touristData);
    }
  }

  componentDidMount() {
    const { allowDocsLater } = this.props;
    const { hideDocInputs } = this.state;
    if (!allowDocsLater && hideDocInputs) {
      // If you choose not to provide document info, but
      // the option is no longer available (due to flight change)
      // TODO: won't work on mobile for validated tourists
      this.handleHideInput(false);
    }
  }

  handleResetTouristData() {
    this.setState({
      name: '',
      surname: '',
    });
  }

  handleHideInput(hideDocInputs) {
    this.handleChange({ hideDocInputs }, true);
  }

  handleHidePatronymic(hidePatronymic) {
    this.handleChange(
      { hidePatronymic, patronymic: hidePatronymic ? '-' : '' },
      true,
    );
  }

  handleFieldChange(field, value) {
    const stateChange = { [field]: value };
    this.handleChange(stateChange);
  }

  handleValidateTourist() {
    const { validateTouristsData, index } = this.props;
    validateTouristsData(index);
  }

  handleChange(stateChange, validate) {
    this.setState(stateChange, () => {
      this.saveTouristsDataImmediately();
      if (validate) {
        const { validateTouristsData, validateTouristField, index } =
          this.props;
        if (size(stateChange) > 1 || stateChange.hideDocInputs !== undefined) {
          validateTouristsData(index);
        } else {
          const [field, value] = entries(stateChange)[0];
          validateTouristField({ index, field, value });
        }
      }
    });
  }

  handleDocTypeChange(docType) {
    const stateChange = { docType };
    const fieldsToClean = [
      T.NAME,
      T.SURNAME,
      T.PATROMYMIC,
      T.DOC_NUMBER,
      T.DOC_EXPIRES_DATE,
    ];
    fieldsToClean.forEach((field) => {
      stateChange[field] = '';
    });
    this.handleChange(stateChange);
  }

  handleSurnameChange(surname) {
    const stateChange = { surname };
    if (surname) {
      // Detecting gender by name
      const swicthNames = getGenderByName(surname) !== null;
      // eslint-disable-next-line
      if (this.state.swicthNames !== false) {
        stateChange.swicthNames = swicthNames || undefined;
      }
    }
    this.handleChange(stateChange);
  }

  handleNameChange(name) {
    const stateChange = { name };
    if (name) {
      // Detecting gender by name
      const gender = getGenderByName(name);
      if (gender) {
        this.handleGenderChange(gender);
      }
    }
    this.handleChange(stateChange);
  }

  handlePatronymicChange(patronymic) {
    const stateChange = { patronymic };
    if (patronymic) {
      // Detecting gender by patronymic
      const gender = getGenderByPatronymic(patronymic);
      if (gender) {
        this.handleGenderChange(gender);
      }
    }
    this.handleChange(stateChange);
  }

  handleNationalityChange(value) {
    this.handleChange({ [T.CITIZENSHIP]: value, passport_number: '' }, true);
  }

  handleGenderChange(gender) {
    // validate on change
    this.handleChange({ gender }, true);
  }

  handleVisaChange(visaType) {
    const { index, updateMockTourist } = this.props;
    this.handleFieldChange('visa_service', visaType);
    setTimeout(() => updateMockTourist({ index, visa_service: visaType }), 0);
  }

  handleDocumentDateChange(value) {
    const { docType } = this.state;
    const { dateField } = DOC_TYPES[docType];
    if (dateField) {
      this.handleFieldChange(dateField.id, value);
    }
  }

  handleSwitchName() {
    const { name, surname } = this.state;
    this.handleNameChange(surname);
    this.handleChange({ [T.SURNAME]: name, swicthNames: undefined });
  }

  handleSwitchNameClose() {
    this.handleChange({ swicthNames: false });
  }

  onTouristSelect(touristData) {
    this.handleChange(touristData, true);
  }

  saveTouristsData() {
    const { index, setTouristsData, age } = this.props;
    setTouristsData({ index, data: { ...this.state, age } });
  }

  render() {
    const {
      age,
      country,
      index,
      visaServices,
      errors,
      allowDocsLater,
      isMobile,
      validations = {},
      isPackagePage,
      touristErrors,
      isHotelOnly,
      showModalCustomer,
      appName,
    } = this.props;
    const {
      docType,
      gender,
      birthday,
      name,
      surname,
      patronymic,
      nationality_id,
      passport_number,
      passport_expires_on,
      hideDocInputs,
      swicthNames,
      visa_service,
      hidePatronymic,
    } = this.state;

    const nameFieldProps = {
      docType,
      onTouristSelect: this.onTouristSelect,
    };
    const commonProps = {
      idx: index,
      errors,
    };
    const { RU, BY } = NATIONALITY_CONSTANTS;
    const canProvideVisaSupport =
      nationality_id === RU || nationality_id === BY;
    const isRussianDoc = isRuDoc(docType);

    const validation = validations[passport_number];

    const showPassportValidationText = Boolean(
      validation?.custom_errors?.booking_passport,
    );

    const showValidationWrongDeparture = Boolean(
      validation?.custom_errors?.wrong_departure,
    );

    const showCustomerInfo =
      index === 0 && !isHotelOnly && showModalCustomer && !HAS_CUSTOMER_FORM;

    const showTouristsMobileBtn =
      isMobile && appName !== MODULE_NAME.ORDER_CHANGING_REQUEST;

    return (
      <div className="tourists-form" data-at-package-tourist-form>
        <TouristsFormHeader
          age={age}
          docType={docType}
          nationalityId={nationality_id}
          isMobile={isMobile}
          country={country}
          handleDocTypeChange={this.handleDocTypeChange}
          onTouristSelect={this.onTouristSelect}
          showCustomerInfo={showCustomerInfo}
        />
        <div
          className="tourists-form__fields"
          onBlur={this.handleValidateTourist}
        >
          {swicthNames && (
            <NameSwicther
              onSwitch={this.handleSwitchName}
              onClose={this.handleSwitchNameClose}
            />
          )}
          <TouristNameField
            {...nameFieldProps}
            {...commonProps}
            stateField={T.SURNAME}
            value={surname}
            label={i18n.t('checkout.registrationForm.surname.header')}
            placeholder={
              isRussianDoc
                ? i18n.t('checkout.registrationForm.surname.header')
                : i18n.t('checkout.touristForm.surname.description')
            }
            onChange={this.handleSurnameChange}
            fieldType="name"
          />
          <TouristNameField
            {...nameFieldProps}
            {...commonProps}
            stateField={T.NAME}
            value={name}
            label={i18n.t('checkout.registrationForm.name.header')}
            placeholder={
              isRussianDoc
                ? i18n.t('checkout.registrationForm.name.header')
                : i18n.t('checkout.touristForm.name.description')
            }
            onChange={this.handleNameChange}
            fieldType="name"
          />
          {isRussianDoc && (
            <TouristPatronymicField
              {...nameFieldProps}
              {...commonProps}
              value={patronymic}
              label={i18n.t('checkout.touristForm.patronymic.title')}
              placeholder={i18n.t('checkout.touristForm.patronymic.title')}
              onChange={this.handlePatronymicChange}
              stateField={T.PATROMYMIC}
              fieldType="patronymic"
              isMobile={isMobile}
              hidePatronymic={hidePatronymic}
              handleHidePatronymic={this.handleHidePatronymic}
            />
          )}
          <TouristGender
            {...commonProps}
            stateField={T.GENDER}
            value={gender}
            onChange={this.handleGenderChange}
          />
          <TouristBirthday
            {...commonProps}
            value={birthday}
            onChange={this.handleBirthdayChange}
            age={age}
            gender={gender}
            stateField={T.BIRTHDAY}
            fieldType="date"
          />
          <TouristCitizenship
            className={cn({ 'last-input': hideDocInputs })}
            {...commonProps}
            stateField={T.CITIZENSHIP}
            value={nationality_id}
            onChange={this.handleNationalityChange}
            fieldType="citizenship"
          />
          <TouristDocument
            {...commonProps}
            docType={docType}
            number={passport_number}
            date={passport_expires_on}
            hideInput={hideDocInputs}
            onHideInput={this.handleHideInput}
            onNumberChange={this.handleDocumentNumberChange}
            onDateChange={this.handleDocumentDateChange}
            allowDocsLater={allowDocsLater}
            nationality_id={nationality_id}
          />
        </div>
        {isPackagePage && (
          <TouristsFormWarnings
            birthday={birthday}
            docsLater={hideDocInputs}
            visaSupportAvailable={canProvideVisaSupport}
            docType={docType}
          />
        )}
        {visaServices && canProvideVisaSupport && (
          <VisaServiceOptions
            {...commonProps}
            visaServices={visaServices}
            value={visa_service}
            onChange={this.handleVisaServiceChange}
          />
        )}
        {showPassportValidationText && !hideDocInputs ? (
          <StyledValidationText>{passportValidationText}</StyledValidationText>
        ) : null}

        <ValidationErrorsList errors={touristErrors} />

        {showValidationWrongDeparture && !hideDocInputs ? (
          <StyledValidationText>
            {wrongDepartureValidationText}{' '}
            <a
              href="https://kz.level.travel/promo"
              target="_blank"
              rel="noreferrer"
            >
              {i18n.t('commonPhrases.readMoreHere')}
            </a>
          </StyledValidationText>
        ) : null}
        {showTouristsMobileBtn && <SubmitTouristMobile index={index} />}
      </div>
    );
  }
}

const StyledValidationText = styled.div`
  background-color: #fce9ec;
  padding: 8px;
  width: 100%;
  border-radius: 6px;
`;

TouristForm.defaultProps = {
  age: null,
  resetGuestData: false,
};

TouristForm.propTypes = {
  adults: PropTypes.number.isRequired,
  country: PropTypes.string.isRequired,
  age: PropTypes.number,
  isMobile: PropTypes.bool.isRequired,
  allowDocsLater: PropTypes.bool.isRequired,
  isVisibleMobileButton: PropTypes.bool,
  resetGuestData: PropTypes.bool,
};

export default TouristForm;
